import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimeSelect from './seat/TimeSelect';
import SeatSelect from './seat/SeatSelect';
import SeatInfoDialog from './seat/SeatInfoDialog';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault, getNowTimeStamp } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import SeatChart from './SeatChart';

const monthList = [
    {
        value: 40320,
        label: '4주(28일)',
    },
    {
        value: 80640,
        label: '8주(56일) 3% 추가할인',
    },
    {
        value: 120960,
        label: '12주(84일) 6% 추가할인',
    },
    {
        value: 161280,
        label: '16주(112일) 9% 추가할인',
    },
    {
        value: 201600,
        label: '20주(140일) 12% 추가할인',
    },
    {
        value: 241920,
        label: '24주(168일) 15% 추가할인',
    },
    {
        value: 282240,
        label: '28주(196일) 18% 추가할인',
    },
    {
        value: 322560,
        label: '32주(224일) 21% 추가할인',
    },
    {
        value: 362880,
        label: '36주(252일) 24% 추가할인',
    },
    {
        value: 403200,
        label: '40주(280일) 27% 추가할인',
    },
    {
        value: 443520,
        label: '44주(308일) 30% 추가할인',
    },
    {
        value: 483840,
        label: '48주(336일) 33% 추가할인',
    },
    {
        value: 524160,
        label: '52주(364일) 36% 추가할인',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    StartDateTextField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 280,
    },
    DateTextField: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 280,
    },
    currentPrepaidTime: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 180,
    },
    seatButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

export default function FixedSeat() {
    const classes = useStyles();

    const [time, setTime] = React.useState();
    const [seat, setSeat] = React.useState();
    const [seatList, setSeatList] = React.useState([]);

    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [doubleDiscount, setDoubleDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const [currentPrepaidTime, setCurrentPrepaidTime] = React.useState();
    const [currentMonthly, setCurrentMonthly] = React.useState();

    const [startDateTime, setStartDateTime] = React.useState('');

    const [reserveList, setReserveList] = React.useState();

    const [seatMap, setSeatMap] = React.useState(false);
    const [seatChart, setSeatChart] = React.useState(false);
    const [allReserveList, setAllReserveList] = React.useState([]);


    const onDateChanged = (e) => {

        //테이블 리스트
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=' + startDateTime + '&time=' + time,
            (data) => {
                setSeatList([data][0]);
                //setSeat([data][0][0].id);
            }
        );

        //계산
        setBill(time, seat);
    }


    const [isSelected, setIsSelected] = React.useState(false);
    const onTimeChanged = event => {
        if (!isSelected) {
            setTime(event.target.value);

            //테이블 리스트
            fetchDefault('/Payment/GetAvailableSeatList?startDateTime=' + startDateTime + '&time=' + event.target.value,
                (data) => {
                    setSeatList([data][0]);
                    //setSeat([data][0][0].id);
                }
            );

            //계산
            setBill(event.target.value, seat);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };

    const onTableChanged = (tableId) => {
        setSeat(tableId);

        //계산
        setBill(time, tableId);
    };

    useEffect(() => {

        setStartDateTime(getNowTimeStamp());

        //내가 예약한 자리 목록
        
        //fetchDefault('/Payment/GetReserveSeatList',
        //    (data) => {
        //        setReserveList(data);
        //    }
        //);


        //판매중지 확인용
        fetchDefault('/Payment/GetBill?time=40320',(data) => {});
        

        return () => {
        }
    }, []);

    const setBill = (time, tableId) => {
        fetchDefault('/Payment/GetBill?startDateTime=' + startDateTime + '&time=' + time + '&tableId=' + tableId,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setDoubleDiscount(data.doubleDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }

    const cancelReserve = (id) => {

        fetchDefault('/Payment/CancelReservation?id=' + id,
            (data) => {
                //내가 예약한 자리 목록
                fetchDefault('/Payment/GetReserveSeatList',
                    (data) => {
                        setReserveList(data);
                    }
                );
            }
        );
    }

    //예약된 전체 자리 보기
    const GetAllSeatInfo = () => {

        fetchDefault('/Seat/GetAllSeatUseInfo',
            (data) => {
                setAllReserveList(data);
                setSeatMap(true);
            }
        );
    }


    //예약된 전체 자리 보기
    const GetAllSeatChart = () => {
        setSeatChart(true);
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>지정석</h2>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                개인석이 전용자리로 지정되어 책상에 짐을 놓고 다닐 수 있습니다.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {reserveList ? (
                    <Grid item xs={12}>
                        {reserveList.map(seat => (
                            <Card style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="body1">
                                        자리 : {seat.tableName}
                                    </Typography>
                                    <Typography variant="body1">
                                        시작 : {seat.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        종료 : {seat.endDateTime}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small" onClick={() => cancelReserve(seat.id)}>
                                        취소하기
                                    </Button>
                                </CardActions>
                            </Card>
                        ))}
                    </Grid>
                ) : (<div></div>)}

                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 기간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="기간"
                        className={classes.StartDateTextField}
                        value={time}
                        onChange={onTimeChanged}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {monthList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 시작날짜를 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="datetime-local"
                        label="시작날짜"
                        className={classes.StartDateTextField}
                        type="datetime-local"
                        value={startDateTime}
                        onChange={e => setStartDateTime(e.target.value)}
                        onBlur={onDateChanged}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 이용을 원하시는 자리를 선택해주세요.
                    </Typography>

                    <Typography variant="body2">
                        (카페를 둘러보시고, 주변에 있는 자리번호를 확인하세요.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SeatSelect tableList={seatList} seat={seat} onTableChanged={onTableChanged} />
                    {/*<SeatInfoDialog onTableChanged={onTableChanged} time={time} />*/}
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <img alt="loading..." src={require('../images/seats_v1.0.png')} style={{ width: 650 }} />
                    </Paper>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatChart}>
                        예약 현황표
                    </Button>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatInfo}>
                        예약 전체 보기
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        4. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} doubleDiscount={doubleDiscount} usePoint={usePoint} myPoint={myPoint} totalPrice={totalPrice} />
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/UseSeat?startDateTime=' + startDateTime + '&time=' + time + '&seat=' + seat} />
                </Grid>
            </Grid>


            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatMap}
                onClose={() => { setSeatMap(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    {allReserveList.map(seat => (
                        <Card style={{ marginBottom: 5 }}>
                            <CardContent>
                                <Typography variant="h6">
                                    {seat.tableName}
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        seat.time.split('/').map(t => {
                                            return <div style={{ marginBottom: 14, marginTop: 14 }}>{
                                                t.split('|').map(a => {
                                                    return <div>{a}</div>;
                                                })
                                            }</div>;

                                        })
                                    }
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatMap(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatChart}
                onClose={() => { setSeatChart(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <SeatChart />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatChart(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/FixedSeat.js